export class CssVarHelper {
  public static read(name: string, document: Document): string {
    return document
      .defaultView!.getComputedStyle(document.documentElement)
      .getPropertyValue(name)
      .trim();
  }
}
